// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-black: #000000;
  --color-white: #FFFFFF;
  --color-yellow: #D4FF00;
  --color-red: #FF4D4D;
  
  --font-primary: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  
  --spacing-xs: 1rem;
  --spacing-sm: 1.5rem;
  --spacing-md: 2rem;
  --spacing-lg: 3rem;
  --spacing-xl: 4rem;
  
  --max-width: 428px;
}`, "",{"version":3,"sources":["webpack://./src/styles/variables.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;;EAEpB,yEAAyE;;EAEzE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,kBAAkB;AACpB","sourcesContent":[":root {\n  --color-black: #000000;\n  --color-white: #FFFFFF;\n  --color-yellow: #D4FF00;\n  --color-red: #FF4D4D;\n  \n  --font-primary: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  \n  --spacing-xs: 1rem;\n  --spacing-sm: 1.5rem;\n  --spacing-md: 2rem;\n  --spacing-lg: 3rem;\n  --spacing-xl: 4rem;\n  \n  --max-width: 428px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
